import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { getOrganizationSlug } from '@/core/organization/parse-subdomain';

import { client } from '../common';
import type { OrganizationLocation } from './types';

type Variables = void;
type Response = OrganizationLocation[];

export const useOrganizationLocations = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['organization/locations'],
  fetcher: () => {
    return client.get(`v2/organizations/locations`).then((response) => {
      return response.data.data;
    });
  },
  enabled: !!getOrganizationSlug(),
});
